import { z } from "zod";

import { MetaDataSchema } from "@/types/meta-data";

import { PriceSchema } from "./price";

export const ProductSchema = z.object({
	id: z.number(),
	name: z.string(),
	description: z.string().nullable(),
	credits: z.number(),
	properties: z.record(z.string(), z.any()),
	prices: z.array(PriceSchema),
});

export const ProductResponseSchema = z.object({
	data: z.array(ProductSchema),
	meta: MetaDataSchema,
});

export type Product = z.infer<typeof ProductSchema>;

export type ProductResponse = z.infer<typeof ProductResponseSchema>;
